module.exports = __webpack_public_path__ + "img/ios-battery-full.992ccb8e.svg";